/**
 * Pure job-health helpers shared by the Scheduled Jobs tab and the admin ops
 * sweep. Kept free of GCP / backend imports so the web app can import this
 * module without pulling Cloud Scheduler into the browser bundle.
 */

/**
 * Cloud Scheduler recomputes `nextScheduleTime` right after every attempt, so
 * an enabled job whose next run has already passed did not just get unlucky —
 * something is stuck. Give the cadence some slack before calling it overdue.
 * Fallback only: the stored ops setting overrides it where the caller has one.
 */
export const DEFAULT_OVERDUE_GRACE_MS = 5 * 60 * 1000;

export function isScheduledJobOverdue(
  job: { state: string; nextScheduleTime: string | null },
  now: number,
  graceMs: number = DEFAULT_OVERDUE_GRACE_MS,
): boolean {
  if (job.state !== 'ENABLED') return false;
  if (!job.nextScheduleTime) return false;
  const next = Date.parse(job.nextScheduleTime);
  if (!Number.isFinite(next)) return false;
  return now - next > graceMs;
}

/**
 * Consecutive-failure streak from the head of `recentRuns` (newest first).
 * Matches the Scheduled Jobs API `computeHealth` badge signal (KTD5).
 */
export function countConsecutiveFailures(
  recentRuns: ReadonlyArray<{ status: string }>,
): number {
  let consecutiveFailures = 0;
  for (const run of recentRuns) {
    if (run.status !== 'FAILED') break;
    consecutiveFailures += 1;
  }
  return consecutiveFailures;
}
